import { Map } from 'immutable'
import * as React from 'react'
import { AsyncState, Pair, Widget, fromJSX } from 'widgets-for-react'
import { ImageSize } from '../types.gen'

export function ImageContainer(
  url: AsyncState<Map<ImageSize, string>>,
  imageSize: ImageSize,
  className: string,
  alt: string,
  get_default_data_src: () => ImageSize,
  get_default_data_srcset: () => Pair<ImageSize, string>[],
  dataSizes?: string
): Widget<never> {
  return fromJSX(() =>
    url.kind === 'loaded' ? (
      <img
        // width="432"
        src={`${url.value.get(imageSize)}`} //ask tim to verify
        data-src={url.value.get(get_default_data_src())}
        data-srcset={get_default_data_srcset()
          .map((e) => `${url.value.get(e[0])} ${e[1]}`)
          .join(',')}
        data-sizes={dataSizes ? dataSizes : 'auto'}
        className={className}
        alt={alt}
      />
    ) : url.kind === 'connection-error' ? (
      <>Error loading image</>
    ) : (
      <></>
    )
  )
}
